<p-carousel [value]="productos" [showIndicators]="false" styleClass="custom-carousel" [numVisible]="2" [numScroll]="1" [circular]="true" [autoplayInterval]="3000" [responsiveOptions]="responsiveOptions">
  <ng-template pTemplate="header">
    <h5>{{titulo}}</h5>
  </ng-template>
  <ng-template let-product pTemplate="item">
    <div class="product-item">
      <div class="product-item-content">
        <div class="product-box">
          <div class="product-img"  [style]= "'max-height: 300px'">
            <ng-container *ngIf="product.en_oferta === 'S'">
              <div class="ribbon ribbon-info">
                {{ "Sale" | translate }}
              </div>
            </ng-container>
            <ng-container *ngIf="product.en_novedad === 'S'">
              <div class="ribbon ribbon-secondary ribbon-right">
                {{ "New" | translate }}
              </div>
            </ng-container>
            <img class="img-fluid img-ofertas product-image" [style]= "'height: 300px; max-height: 300px'" src={{product.imagen1}} alt="">
            <div class="product-hover">
              <ul>
                <ng-container  *ngIf="(rol == 1 || rol == 2) ? (controlStock && product.stock > 0) || !controlStock : false">
                  <li *ngIf="mostrarPrecio">
                    <button class="btn" type="button" (click)="addCart(product)"><i class="icon-shopping-cart"></i></button>
                  </li>
                </ng-container>
                <li><a [routerLink]="['/productos', product.codigo]"> <!-- (click)="modalView(product)" -->
                  <button class="btn" type="button" ><i class="icon-eye"></i></button></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="product-details">
            <span>{{product.marca}}</span>
            <h4 style="min-height: 50px;">{{product.nombrecorto}}</h4>
            <p>COD: {{product.codigo}}</p>
            <div *ngIf="config.productos.muestra_unidad_bulto">
              <p>UNID: {{product.cantidad_unidad}}</p>
              <p>BULTO: {{product.cantidadpaq}}</p>
          </div>
          <ng-container *ngIf="product.stock <= 0"
            ><label class="badge badge-danger">{{
              tituloSinStock
            }}</label>
          </ng-container>
          <ng-container
            *ngIf="(mostrarEtiquetaMinimo) ? product.stock > 0 && product.stock <= product.cantidad_minima : false"
            ><label class="badge badge-warning"
              >{{tituloStockMinimo}}</label
            ></ng-container
          >
          <ng-container
            *ngIf="(mostrarEtiquetaMinimo) ? product.stock > 0 && product.stock > product.cantidad_minima : product.stock > 0"
            ><label class="badge badge-success"
              >{{tituloStockDisponible}}</label
            ></ng-container
                    >

            <div *ngIf="mostrarPrecio">
              <!-- Precio Final -->
              <div *ngIf="mostrarPrecioFinalRjt || invitado">
                <div class="product-price">${{product.precio_final | currency:'' :'':'.2-2':'es'}}</div>
                <span>{{config.productos.titulo_precio_final}}</span>
              </div>

              <!-- Precio Neto -->
              <!-- <div *ngIf="config.productos.muestra_precio_neto && !invitado">
                <div class="product-price">${{product.precio_neto | currency:'' :'':'.2-2':'es'}}</div>
                <span>{{config.productos.titulo_precio_neto}}</span>
              </div> -->

              <!-- Precio Neto -->
              <div *ngIf="mostrarPrecioRjtSinIva && !invitado">
                <div class="product-price">${{product.precio_neto | currency:'' :'':'.2-2':'es'}}</div>
                <span>{{config.productos.titulo_precio_neto}}</span>
              </div>
            </div>
      
        </div>
      </div>
    </div>
    </div>
  </ng-template>
</p-carousel>